export default __webpack_public_path__ + "static/media/telegram.9993055f.svg";